import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 1rem;
    gap: 1rem;
    max-height: 80vh;
    overflow-y: auto;
`
